import { Holder, Tip, TitleHolder, TitleImage, Container } from "./VisionariesSlide1.style"

import TitleIcon from "./title.svg"

export default function VisionariesSlide1() {
  return (
    <Holder>
      <Container>
        <TitleHolder>
          <TitleImage src={TitleIcon} alt="" />
        </TitleHolder>
        <Tip>
          Folio Gardens is the exciting third phase to launch at Postmark, enhancing the already
          established phases with a brand new bustling public square at the heart of Farringdon,
          complete with landscaped gardens and a lively mix of shops, workspaces and cafés for the
          whole community to enjoy. Meet the teams behind the major new developement.
        </Tip>
      </Container>
    </Holder>
  )
}
